import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import Login from "../views/Login";
import Index from '../views/Index';
import My from '../views/My'
import Reserve from "../views/Reserve";
import Footer from "../components/Footer";
import Hall from "../views/Hall";
import CollList from "../views/CollList";
import Bid from "../views/Bid";
import Search from "../views/Search";
import HallRef from "../views/HallRef";
Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            isLogin: false
        }
    }, {
        path: '/',
        name: 'Home',
        components: {
            default: Index,
            footer: Footer
        },
        meta: {
            isLogin: false
        }
    }, {
        path: '//',
        name: 'Home',
        components: {
            default: Index,
            footer: Footer
        },
        meta: {
            isLogin: false
        }
    }, {
        path: '/my',
        name: 'My',
        components: {
            default: My,
            footer: Footer
        },
        meta: {
            isLogin: true,
            autoRedirect: false
        }
    },
    {
        path: '/reserve',
        name: 'Reserve',
        components: {
            default: Reserve,
            footer: Footer
        },
        meta: {
            isLogin: false
        }
    },
    {
        path: '/hall',
        name: 'Hall',
        components: {
            default: Hall,
            footer: Footer
        },
        meta: {
            isLogin: false,
            autoRedirect: false
        }
    }, {
        path: '/hallref',
        name: 'HallRef',
        components: {
            default: HallRef,
            footer: Footer
        },
        meta: {
            isLogin: false,
            autoRedirect: false
        }
    }, {
        path: '/colllist',
        name: 'CollList',
        components: {
            default: CollList,
            footer: Footer
        },
        meta: {
            isLogin: false,
            autoRedirect: false //不自动跳转
        }
    }, {
        path: '/bid',
        name: 'Bid',
        components: {
            default: Bid,
            footer: Footer
        },
        meta: {
            isLogin: true,
            autoRedirect: false //不自动跳转
        }
    }, {
        path: '/search',
        name: 'Search',
        components: {
            default: Search,
            footer: Footer
        },
        meta: {
            isLogin: false,
            autoRedirect: false //不自动跳转
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.name === 'Hall') {
            return { x: 0, y: 0 }
        } else {
            savedPosition
        }
    }
})


/*路由鉴权*/
router.beforeEach((to, from, next) => {
    if (to.name == null) {
        window.location.href = '/'
    }


    if (to.meta.isLogin && !store.state.isLogin) {
        console.warn('此页面需要登录，请先登录~')
        next({
            name: "Login", params: {
                uri: to.name === 'Login' ? '/' : to.name
            }
        })

    }

    if (process.env.NODE_ENV === 'development') {
        //开发环境不自动判断设备
        next()
    } else {
        //根据浏览环境自动重定向
        if (to.meta.autoRedirect !== false) {
            const domain = 'https://report.dichan.com'
            if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
                //当前环境是手机端：执行 PC->H5

            } else {
                //当前环境是PC端： 执行 H5->PC
                location.href = domain + to.path
                return
            }
        } else {
            console.log("路由已设置 不自动重定向")
        }
        next()
    }

})

export default router
